<sl-label size="small" *ngIf="label != null">{{label}}</sl-label>
<div>

    <sl-select size="small" name="start" [disabled]="disabled" [value]="periodInMillis.start"
        (slSelect)="onStartChange($event)" hoist>
        <sl-menu-item *ngFor="let pit of pits" [value]="pit.getTime()">{{pit | date:'shortTime'}}</sl-menu-item>
    </sl-select>
    <sl-label size="small" i18n>to</sl-label>
    <sl-select size="small" name="end" [disabled]="disabled" [value]="periodInMillis.end"
        (slSelect)="onEndChange($event)" hoist>
        <sl-menu-item *ngFor="let pit of pits" [value]="pit.getTime()">{{pit | date:'shortTime'}}</sl-menu-item>
    </sl-select>
</div>